import { render, staticRenderFns } from "./ListaMedicosUnidade.vue?vue&type=template&id=2a64b96c&scoped=true"
import script from "./ListaMedicosUnidade.vue?vue&type=script&lang=js"
export * from "./ListaMedicosUnidade.vue?vue&type=script&lang=js"
import style0 from "./ListaMedicosUnidade.vue?vue&type=style&index=0&id=2a64b96c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64b96c",
  null
  
)

export default component.exports